// export function buildIdFilterArray(data: any, formData: any) {
//     // Get the first key and associated object in the data
//     const firstKey = Object.keys(data)[0];
//     const value = data[firstKey];
//     const updatedFilter: any = {};

//     // Populate updatedFilter with keys ending in '_id' and resolve "this.{key}" format from formData
//     for (const key in value) {
//         if (key.endsWith('_id')) {
//             let filterValue = value[key];

//             // If filter value is in the format "this.{key}", replace it with formData value
//             if (typeof filterValue === "string" && filterValue.startsWith("this.")) {
//                 const actualKey = filterValue.slice(5); // Remove "this." prefix
//                 filterValue = formData.hasOwnProperty(actualKey) ? formData[actualKey] : filterValue;
//             }

//             updatedFilter[key] = filterValue;
//             break; // Exit loop after finding the first matching '_id' key
//         }
//     }

//     // Convert updatedFilter to an array of objects with key, value, and type information
//     return Object.entries(updatedFilter).map(([key, value]) => ({
//         key,
//         value,
//         type: typeof value === "number" ? "Number" : "String",
//     }));
// }

export function buildIdFilterArray(filter: any, formData: any) {
  // Create a new object to avoid modifying the original filter object
  const updatedFilter = { ...filter };

  // Iterate over each key-value pair in the filter object
  console.log("filter", filter);
  console.log("updatedFilter", updatedFilter);
  console.log("formData isnide buildIdFilterArray", formData);

  for (const key in updatedFilter) {
    console.log("formData.hasOwnProperty(key)", formData.hasOwnProperty(key));
    if (formData.hasOwnProperty(key)) {
      const value = updatedFilter[key];

      // Check if the value is in the format of "this.{some_key}"
      if (typeof value === "string" && value.startsWith("this.")) {
        // Extract the actual key without the "this." prefix
        const actualKey = value.split("this.")[1];

        // Replace the filter value with the value from formdata if it exists, else retain the original
        updatedFilter[key] = formData.hasOwnProperty(actualKey)
          ? formData[actualKey]
          : value;
        // updatedFilter[key] = value;
      }
    }
  }
  let idFilter = extractIdFromFirstMatchingKey(updatedFilter);
  console.log("idFilter", idFilter);
  // let frupdatedFilter=[{key:"client_id",value:940,type:"Number"}];
  const filterArray = Object.keys(idFilter).map((key) => ({
    key: key,
    value: idFilter[key],
    type: typeof idFilter[key] === "number" ? "Number" : "String",
  }));

  console.log("filterArray", filterArray);
  return filterArray;
}

function extractIdFromFirstMatchingKey(data: any) {
  // Iterate through all keys in the object
  let key2 = Object.keys(data)[0];
  console.log(key2);
  let value2 = data[key2];
  console.log(value2);
  let filter: any = {};
  for (let key in value2) {
    // console.log(value2[key]);
    if (key.endsWith("_id")) {
      // If the object at this key has an '_id', return it directly
      console.log("key", key);
      console.log("value2", value2);
      filter = { [key]: value2[key] };
    }
  }
  return filter; // Return null if no matching key was found
}
